import { defineMessages } from 'react-intl';

export const sharedMessages = defineMessages({
  ms: {
    defaultMessage: 'Frau',
    id: 'sampleOrder.personalDataForm.labels.ms',
  },
  mr: {
    defaultMessage: 'Herr',
    id: 'sampleOrder.personalDataForm.labels.mr',
  },
  deliveryAddress: {
    defaultMessage: 'Lieferadresse',
    id: 'sampleOrder.personalDataForm.card.header',
  },
});
